import { ExplodedCategory } from './ExplodedCategory';

export default ExplodedCategory;
